var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('script-title-inline-editor',{staticClass:"inline-input",attrs:{"script-id":_vm.init.id,"value":_vm.value}},[_c('span',{staticClass:"inline-text",domProps:{"textContent":_vm._s(_vm.value)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }